import React from 'react';

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="auth-bg">
      <div className="auth-container">
        <div className="auth-hero">
          <div className="auth-hero-inner">
            <div className="brand">Admintools</div>
            <h2>Secure access to your workspace</h2>
            <p>Sign in to manage uploads, jobs and your accounting integrations.</p>
          </div>
        </div>
        <div className="auth-card">
          <h1 className="auth-title">{title}</h1>
          {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          {children}
          {footer && <div className="auth-footer">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
